// 产品管理
import http from "@/jslibs/axios/http";
import utils from "@/jslibs/utils";

// 产品列表
export const list = (data) => http.get("/v1/cms/Goods", data);

// 产品新增
export const add = (data) => http.post("/v1/cms/Goods", data);

// 产品编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/Goods/${uuid}`, data);

// 产品详情
export const detail = ({ cuuid, ...data }) => http.get(`/v1/cms/Goods/${cuuid}`, data);

// 产品删除
export const del = ({ cuuid }) => http.delete(`/v1/cms/Goods/${cuuid}`);

// 基础数据
export const data = ({ cuuid, ...data }) => http.get(`/v1/cms/Goods/data/${cuuid}`, data);

// 用户浏览记录
export const history = ({ cuuid, ...data }) => http.get(`/v1/cms/Goods/goods_history/${cuuid}`, data);

// 产品导入
export const _import = ({ file }) => {
    const params = new FormData();
    params.append("file", file);
    const config = {
        "Content-Type": "multipart/form-data;charset=utf-8",
    };
    return http.post("/v1/cms/Goods/import", params, config);
};

// 产品导入模板下载
export const download = () => utils.downloadFile(`/v1/cms/Goods/template?export=1`);
